import { Image } from '@/components/common/image';
import { AgentV2PushContentDetailData } from '@/services/agent-v2-push-content-detail';

/** 左侧朋友圈区域 */
export const LeftMoments: React.FC<{ details: AgentV2PushContentDetailData }> = ({ details }) => {
  return (
    <div className='flex-1 h-full relative bg-white flex flex-col border-r border-r-[rgba(233,234,235,1)] py-[30px] px-6'>
      <div className='flex overflow-hidden'>
        <div className="size-10 rounded-[4px] flex-shrink-0 mr-[10px]">
          <Image src={details?.userAvatar || ''} className="size-full rounded-[4px] object-cover" />
        </div>
        <div className='flex flex-col'>
          <div className='text-[15px] font-medium text-[rgba(16,24,40,1)] mb-2 leading-none'>
            {details?.userName || ''}
          </div>
          <div className='text-[15px] text-[rgba(25,25,25,1)]  overflow-y-auto'>
            <div className='mb-3'>
              {details?.content || ''}
            </div>
            <div className='flex flex-wrap gap-0.5'>
              {details?.imageUrls?.map((url, index) => (
                <div key={index} className='size-[84px]'>
                  <Image src={url} className="size-full  object-cover" />
                </div>
              ))}
            </div>
            <div className='text-sm text-[rgba(102,112,133,1)] mt-3'>
              3小时前
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
